
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom
import "../../assets/css/Error.css"

import img from '../../assets/images/404 error (1).svg';
import logo from '../../assets/images/Frame 7 (1).svg';
import '../../assets/css/errorpage599.css';
const ErrorPage = () => {
    const navigate = useNavigate(); // Initialize navigate hook

    const goHome = () => {
        navigate('/'); // Navigates to the home page
    };
    
    return (
        <div className="main-body">
            <section>
                <div className='container' style={{ marginTop: '198px' }}>
                    <div className="row"  style={{marginTop:'179px'}}>
                        <div className="col-lg-6">
                            <div>
                                <img src={img} alt="Error" />
                                <span>
                                    <p style={{ marginTop: '-39px', marginLeft: '197px' }}>
                                    Not Found   </p>
                                </span>

                                <div>
                                    <p style={{ fontSize: '30px', fontWeight: '600', color: '#2196F3', marginTop: '56px' }}>
                                    Uhm...
                                    </p>
                                    <p style={{ fontSize: '18px', fontWeight: '500', lineHeight: '32px', color: '#666666', marginTop: '20px' }}>
                                    The requested page doesn’t exist. Please double-check the URL or return to the homepage.
                                    </p>
                                </div>
                                <button
                                    style={{
                                        width: '83px',
                                        height: '37px',
                                        borderRadius: '10px',
                                        color: '#fff',
                                        backgroundColor: '#2196F3',
                                        border: 'none',
                                        marginLeft: '15px',
                                        marginTop: '37px'
                                    }}
                                   onClick={()=>{goHome()}}
                                >
                                  Home
                                </button>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <img src={logo} style={{ width: '83%', marginLeft: '103px' }} className='img' alt="Logo" />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default ErrorPage;